<div>
  <div>
    <div class="row margin-top-8">
      <div class="reservation-header">
        {{'bikeshop.rentals.booking.create_reservation' | translate }}
      </div>
    </div>

    <div class="row margin-top-8">
      <div class="col-4" *ngIf="affiliates && affiliates.length > 0"><button pButton
          class="p-button-raised p-mini full-width" label="{{'bikeshop.rentals.booking.link_affiliate' | translate}}"
          (click)="addAffiliate=true" [disabled]="addAffiliate"></button></div>
      <div class="col-4" *ngIf="rentalStoreRules.enableDeliveries">
        <button pButton class="p-button-raised p-mini full-width"
          label="{{'bikeshop.rentals.booking.add_delivery_collection' | translate}}" (click)="addDeliveryCollections()"
          [disabled]="addDelivery"></button>
      </div>
    </div>

    <div class="info-container" *ngIf="affiliates && affiliates.length > 1 && addAffiliate">
      <div class="label header">{{ 'bikeshop.rentals.booking.affilaite' | translate }}</div>

      <div class="row margin-top-16">
        <div class="col-md-2 label">{{ "bikeshop.rentals.booking.linked_affilaite" | translate }}:</div>
        <div class="col-md-4 value dropdown-clear">
          <p-dropdown class="affiliate-drop" [options]="affiliates" [(ngModel)]="bookingInfo.affiliateID">
          </p-dropdown>
        </div>
        <div class="col-md-1 dropdown-clear" *ngIf="bookingInfo.affiliateID">
          <div class="remove-affiliate"><span class="fa fa-times-circle"
              (click)="bookingInfo.affiliateID = null;"></span></div>
        </div>
      </div>
    </div>


    <div class="info-container">
      <app-cyclist [partnerId]="partner.ID" user="{}" (update)="addUser($event)" [nextCyclist]="null"
        [messageService]="messageService"></app-cyclist>
    </div>

    <div class="info-container" *ngIf="rentalStoreRules.hasDemoProducts">
      <div class="row">
        <div class="col-md-2 label">{{ 'bikeshop.rentals.booking.reservation_type' | translate }}:</div>
        <div class="col-md-10">
          <div class="reservation-type-container">
            <div><p-radioButton name="type" [value]="false" (click)="getAvailableProducts()"
                label="{{ 'bikeshop.rentals.booking.type_rental' | translate }}"
                [(ngModel)]="bookingInfo.isDemo"></p-radioButton></div>
            <div><p-radioButton name="type" [value]="true" (click)="getAvailableProducts()"
                label="{{ 'bikeshop.rentals.booking.type_demo' | translate }}"
                [(ngModel)]="bookingInfo.isDemo"></p-radioButton></div>
          </div>
        </div>
      </div>
    </div>


    <div class="info-container" *ngIf="addDelivery">
      <div class="header-edit">
        <div class="label header">{{'bikeshop.rentals.booking.delivery_collection_information' | translate}}</div>
      </div>

      <div>
        <div>
          <div class="rental-duration" *ngIf="bookingInfo.deliveryInformation">
            <div class="row margin-top-16">
              <div class="col-md-3 label">{{'bikeshop.modal.update_job_card.collections.delivery' | translate }}:
              </div>
              <div class="col-md-3 flex"><p-inputSwitch
                  [(ngModel)]="bookingInfo.deliveryInformation.isDelivery"></p-inputSwitch></div>
              <div *ngIf="!bookingInfo.deliveryInformation.isDelivery" class="label col-md-3"
                [ngClass]="{ 'red' : bookingInfo.fromDate === null}">
                {{ 'bikeshop.rentals.booking.from' | translate }}:
              </div>
              <div *ngIf="!bookingInfo.deliveryInformation.isDelivery" class="col-md-3">
                <div class="input-icon-right">
                  <p-calendar #calendar inputId="fromDate" [dateFormat]="countryData.DatePickerFormat"
                    [hideOnDateTimeSelect]="true" [(ngModel)]="bookingInfo.fromDate" [readonlyInput]="true"
                    [hourFormat]="'12'" [showOtherMonths]="false" [showTime]="true" [showSeconds]="false" [stepHour]="1"
                    [stepMinute]="15" (onClose)="datesUpdated()"></p-calendar>
                  <i class="fa fa-calendar"></i>
                </div>
              </div>
            </div>
            <div class="row margin-top-8" *ngIf="bookingInfo.deliveryInformation.isDelivery">
              <div class="col-md-3 label"
                [ngClass]="{'red': bookingInfo.deliveryInformation.isDelivery && !bookingInfo.deliveryInformation.fullAddress}">
                {{ 'bikeshop.modal.update_job_card.collections.delivery_address' | translate }}:
              </div>
              <div class="col-md-6">
                <div class="p-inputgroup">
                  <p-autoComplete [(ngModel)]="bookingInfo.deliveryInformation.fullAddress"
                    [suggestions]="addressOptions" (completeMethod)="searchAddress($event, 'DELIVERY')"
                    (onSelect)="onAddressSelect($event,'DELIVERY')" field="address"></p-autoComplete>
                  <div *ngIf="deliveryAddressLoading">
                    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
                      animationDuration=".5s"></p-progressSpinner>
                  </div>
                </div>
              </div>
            </div>
            <div class="row"
              *ngIf="bookingInfo.deliveryInformation.fullAddress && bookingInfo.deliveryInformation.addressOutOfRange">
              <div class="col-3"></div>
              <div class="col-9 address-not-in-range">{{ 'bikeshop.rentals.booking.no_areas_for_address' | translate }}
              </div>
            </div>
            <div class="row margin-top-8" *ngIf="bookingInfo.deliveryInformation.isDelivery">
              <div class="col-md-3 label" [ngClass]="{'red': !bookingInfo.deliveryInformation.scheduleDate}">
                {{'bikeshop.collections.date' | translate }}:</div>
              <div class="col-md-3">
                <div class="input-icon-right">
                  <p-calendar #calendar inputId="basic" [minDate]="minDate"
                    placeholder="{{'bikeshop.modal.update_job_card.collections.delivery_date' | translate}}"
                    [dateFormat]="countryData.DatePickerFormat" [hideOnDateTimeSelect]="true"
                    [(ngModel)]="bookingInfo.deliveryInformation.scheduleDate" [readonlyInput]="true"
                    [disabledDates]="disabledDeliveryDates" (onSelect)="deliveryDateSelected($event)"
                    [disabled]="!bookingInfo.deliveryInformation.addressDetails && !bookingInfo.deliveryInformation.areaID"
                    (onFocus)="datePickerFocused($event)" (onClose)="datePickerClosed($event)" [showOtherMonths]="false"
                    (onMonthChange)="onDeliveryMonthChange($event)"></p-calendar>
                  <i class="fa fa-calendar"></i>
                </div>
              </div>
            </div>
            <div class="row margin-top-8" *ngIf="bookingInfo.deliveryInformation.isDelivery">
              <div class="col-md-3 label" [ngClass]="{'red': !bookingInfo.deliveryInformation.slot}">
                {{'bikeshop.modal.update_job_card.collections.delivery_time_slot' | translate }}:</div>
              <div class="col-md-3"><p-dropdown [options]="deliveryTimeSlots"
                  (onChange)="selectDeliveryTimeSlot($event)"
                  [disabled]="bookingInfo.deliveryInformation.scheduleDate=== null || deliveryTimeSlots.length === 0"
                  [ngModel]="bookingInfo.deliveryInformation.slot" optionLabel="label"
                  placeholder="{{ 'bikeshop.modal.update_job_card.collections.delivery_time_slot' | translate}}"></p-dropdown>
              </div>
            </div>
          </div>


          <div class="rental-duration" *ngIf="bookingInfo.collectionInformation">
            <div class="row margin-top-16">
              <div class="col-md-3 label">{{'bikeshop.modal.update_job_card.collections.collection' | translate
                }}:</div>
              <div class="col-md-3 flex"><p-inputSwitch
                  [(ngModel)]="bookingInfo.collectionInformation.isCollection"></p-inputSwitch></div>

              <div *ngIf="!bookingInfo.collectionInformation.isCollection" class="label col-md-3"
                [ngClass]="{ 'red' : bookingInfo.toDate === null || bookingInfo.toDate <= bookingInfo.fromDate}">
                {{ 'bikeshop.rentals.booking.to' | translate }}:
              </div>
              <div *ngIf="!bookingInfo.collectionInformation.isCollection" class="col-md-3">
                <div class="input-icon-right">
                  <p-calendar #calendar inputId="toDate" [dateFormat]="countryData.DatePickerFormat"
                    [hideOnDateTimeSelect]="true" [(ngModel)]="bookingInfo.toDate" [readonlyInput]="true"
                    [hourFormat]="'12'" [showOtherMonths]="false" [showTime]="true" [showSeconds]="false" [stepHour]="1"
                    [stepMinute]="15" [minDate]="bookingInfo.fromDate" (onClose)="datesUpdated()"></p-calendar>
                  <i class="fa fa-calendar"></i>
                </div>
              </div>
            </div>
            <div class="row margin-top-8" *ngIf="bookingInfo.collectionInformation.isCollection">
              <div class="col-md-3 label"
                [ngClass]="{'red': bookingInfo.collectionInformation.isCollection && !bookingInfo.collectionInformation.fullAddress}">
                {{ 'bikeshop.modal.update_job_card.collections.collection_address' | translate }}:
              </div>
              <div class="col-md-6">
                <div class="p-inputgroup">
                  <p-autoComplete [(ngModel)]="bookingInfo.collectionInformation.fullAddress"
                    [suggestions]="addressOptions" (completeMethod)="searchAddress($event, 'COLLECTION')"
                    (onSelect)="onAddressSelect($event,'COLLECTION')" field="address"></p-autoComplete>
                  <div *ngIf="collectionAddressLoading">
                    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
                      animationDuration=".5s"></p-progressSpinner>
                  </div>
                </div>
              </div>
            </div>
            <div class="row"
              *ngIf="bookingInfo.collectionInformation.fullAddress && bookingInfo.deliveryInformation.addressOutOfRange">
              <div class="col-3"></div>
              <div class="col-9 address-not-in-range">{{ 'bikeshop.rentals.booking.no_areas_for_address' | translate }}
              </div>
            </div>
            <div class="row margin-top-8" *ngIf="bookingInfo.collectionInformation.isCollection">
              <div class="col-md-3 label" [ngClass]="{'red': !bookingInfo.collectionInformation.scheduleDate}">
                {{'bikeshop.collections.date' | translate }}:</div>
              <div class="col-md-3">
                <div class="input-icon-right">
                  <p-calendar #calendar inputId="basic" [minDate]="minCollectionDate" [maxDate]="maxCollectionDate"
                    placeholder="{{'bikeshop.modal.update_job_card.collections.collection_date' | translate}}"
                    [dateFormat]="countryData.DatePickerFormat" [hideOnDateTimeSelect]="true"
                    [(ngModel)]="bookingInfo.collectionInformation.scheduleDate" [readonlyInput]="true"
                    [disabledDates]="disabledCollectionDates" (onSelect)="collectionDateSelected($event)"
                    [disabled]="!bookingInfo.collectionInformation.addressDetails && !bookingInfo.collectionInformation.areaID"
                    (onFocus)="datePickerFocused($event)" (onClose)="datePickerClosed($event)" [showOtherMonths]="false"
                    (onMonthChange)="onCollectionMonthChange($event)"></p-calendar>
                  <i class="fa fa-calendar"></i>
                </div>
              </div>
            </div>
            <div class="row margin-top-8" *ngIf="bookingInfo.collectionInformation.isCollection">
              <div class="col-md-3 label" [ngClass]="{'red': !bookingInfo.collectionInformation.slot}">
                {{'bikeshop.modal.update_job_card.collections.delivery_time_slot' | translate }}:</div>
              <div class="col-md-3"><p-dropdown [options]="collectionTimeSlots"
                  (onChange)="selectCollectionTimeSlot($event)"
                  [disabled]="bookingInfo.collectionInformation.scheduleDate=== null || collectionTimeSlots.length === 0"
                  [ngModel]="bookingInfo.collectionInformation.slot" optionLabel="label"
                  placeholder="{{ 'bikeshop.modal.update_job_card.collections.collection_time_slot' | translate}}"></p-dropdown>
              </div>
            </div>
          </div>
        </div>


        <div *ngIf="rentalStoreRules.allowFixedRentalOptions && !rentalStoreRules.allowFlexibleRentalOptions">
          <div class="row margin-top-16">
            <div class="col-md-12 label" [ngClass]="{'red bold': selectedTimeUnit === null}">
              {{ 'bikeshop.rentals.booking.override_time_unit' | translate }}
            </div>
          </div>
          <div class="row margin-top-8">
            <div class="label col-md-12">
              <div class="duration-container">
                <div *ngFor="let timeUnit of availableTimeUnits" class="custom-button"
                  [ngClass]="{'selected': timeUnit == selectedTimeUnit}"
                  (click)="selectedTimeUnit=timeUnit;bookingInfo.unitType = timeUnit.unitType">
                  {{timeUnit.unit}} {{timeUnit.unitType}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="rentalStoreRules.allowFlexibleRentalOption && bookingInfo.rentalDays > 0">
          <div class="rental-days-message">
            <div>{{
              'bikeshop.rentals.booking.days_reserved_exact' | translate : {days: bookingInfo.rentalDays} }}
            </div>
          </div>
        </div>

      </div>
    </div>









    <div class="info-container" *ngIf="!addDelivery">

      <div class="header-edit">
        <div class="label header">{{'bikeshop.rentals.booking.reservation_dates' | translate}}</div>
        <div><span>{{ 'bikeshop.rentals.booking.override_date' | translate }}</span>
          <p-inputSwitch [(ngModel)]="overrideDateControl" (onChange)="dateOverrideUpdated()"></p-inputSwitch>
        </div>
      </div>

      <div *ngIf="!overrideDateControl">
        <app-rentals-availability-date-picker [reservation]="bookingInfo" [rentalConfig]="rentalStoreRules"
          [countryData]="countryData" (dateUpdated)="dateUpdated()"></app-rentals-availability-date-picker>
      </div>


      <!-- <div *ngIf="!overrideDateControl">
        <div class="row margin-top-16">
          <div class="label col-md-2"
            [ngClass]="{ 'red' : bookingInfo.selectedDate === null || bookingInfo.selectedDate < minDate}">
            {{ 'bikeshop.rentals.booking.from_date' | translate }}:
          </div>
          <div class="col-md-3">
            <div class="input-icon-right">
              <p-calendar #calendar inputId="basic" [minDate]="minDate" [dateFormat]="countryData.DatePickerFormat"
                [hideOnDateTimeSelect]="true" [(ngModel)]="bookingInfo.fromDate" [readonlyInput]="true"
                [disabledDates]="disabledDates" (onSelect)="fromDateSelected($event)"
                (onFocus)="datePickerFocused($event)" (onClose)="datePickerClosed($event)" [showOtherMonths]="false"
                (onMonthChange)="onMonthChange()"></p-calendar>
              <i class="fa fa-calendar"></i>
            </div>
          </div>
        </div>

        <div class="margin-top-16 red bold" *ngIf="bookingInfo.fromDate < minDate">
          {{ 'bikeshop.rentals.booking.date_past_validation_warning' | translate }}
        </div>
        <div class="margin-top-16 red bold"
          *ngIf="!loadingAvailability && availableSlots && availableSlots.length === 0 && bookingInfo.fromDate >= minDate">
          {{ 'bikeshop.rentals.booking.no_time_slots' | translate }}
        </div>

        <div *ngIf="loadingAvailability">
          <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
            animationDuration=".5s">
          </p-progressSpinner>
        </div>

        <div class="row margin-top-16"
          *ngIf="bookingInfo.fromDate && availableSlots && availableSlots.length > 0 && !loadingAvailability">
          <div class="col-md-2 label" [ngClass]="{'red' : !bookingInfo.selectedSlot}">{{
            'bikeshop.rentals.booking.pickup_time' | translate }}:</div>
          <div class="col-md-10">
            <div class="slots-container">
              <div *ngFor="let slot of availableSlots" (click)="slotSelected(slot)" class="custom-button"
                [ngClass]="{'selected': slot === bookingInfo.selectedSlot}">
                <div>{{slot.label}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="row margin-top-16"
          *ngIf="bookingInfo && bookingInfo.fromDate && bookingInfo.selectedSlot && bookingInfo.selectedSlot.durations && !loadingAvailability">
          <div class="col-md-2 label" [ngClass]="{'red' : !bookingInfo.selectedDuration}">{{
            'bikeshop.rentals.booking.rental_duration' | translate }}:</div>
          <div class="col-md-10">
            <div class="duration-container">
              <div *ngFor="let duration of bookingInfo.selectedSlot.durations" (click)="durationSelected(duration)"
                class="custom-button" [ngClass]="{'selected': duration === bookingInfo.selectedDuration}">
                <div>{{duration.unit}} {{duration.unitType}}{{duration.unit != 1 ? 's' : ''}}</div>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <div *ngIf="overrideDateControl">
        <div class="row margin-top-16">
          <div class="label col-md-2" [ngClass]="{ 'red' : bookingInfo.fromDate === null}">
            {{ 'bikeshop.rentals.booking.from' | translate }}:
          </div>
          <div class="col-md-3">
            <div class="input-icon-right">
              <p-calendar #calendar1 inputId="fromDate" [dateFormat]="countryData.DatePickerFormat"
                [hideOnDateTimeSelect]="true" [(ngModel)]="bookingInfo.fromDate" [readonlyInput]="true"
                [hourFormat]="'12'" [showOtherMonths]="false" [showTime]="true" [showSeconds]="false" [stepHour]="1"
                [stepMinute]="15" (onClose)="dateUpdated()"></p-calendar>
              <i class="fa fa-calendar"></i>
            </div>
          </div>
          <div class="label col-md-2"
            [ngClass]="{ 'red' : bookingInfo.toDate === null || bookingInfo.toDate <= bookingInfo.fromDate}">
            {{ 'bikeshop.rentals.booking.to' | translate }}:
          </div>
          <div class="col-md-3">
            <div class="input-icon-right">
              <p-calendar #calendar2 inputId="toDate" [dateFormat]="countryData.DatePickerFormat"
                [defaultDate]="minDate" [minDate]="bookingInfo.fromDate" [hideOnDateTimeSelect]="true"
                [(ngModel)]="bookingInfo.toDate" [readonlyInput]="true" [hourFormat]="'12'" [showOtherMonths]="false"
                [showTime]="true" [showSeconds]="false" [stepHour]="1" [stepMinute]="15"
                (onClose)="dateUpdated()"></p-calendar>
              <i class="fa fa-calendar"></i>
            </div>
          </div>
        </div>
        <div class="row margin-top-8">
          <div class="col-md-12 orange bold" *ngIf="bookingInfo.fromDate < minDate">
            {{ 'bikeshop.rentals.booking.date_in_the_past' | translate }}
          </div>
        </div>
        <div *ngIf="showFixedSlots()">
          <div class="row margin-top-16">
            <div class="col-md-12 label" [ngClass]="{'red bold': selectedTimeUnit === null}">
              {{ 'bikeshop.rentals.booking.override_time_unit' | translate }}
            </div>
          </div>
          <div class="row margin-top-8">
            <div class="label col-md-12">
              <div class="duration-container">
                <div *ngFor="let timeUnit of availableTimeUnits" class="custom-button"
                  [ngClass]="{'selected': timeUnit == selectedTimeUnit}"
                  (click)="selectedTimeUnit=timeUnit;bookingInfo.unitType = timeUnit.unitType">
                  {{timeUnit.unit}} {{timeUnit.unitType}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="showFlexibleOptions()">
          <div class="rental-days-message">
            <div *ngIf="rentalDaysMessage==='EXACT' || rentalDaysMessage==='UNDER' ">{{
              'bikeshop.rentals.booking.days_reserved_exact' | translate : {days: bookingInfo.rentalDays} }}</div>
            <div *ngIf="rentalDaysMessage==='OVER'">{{ 'bikeshop.rentals.booking.days_reserved_over' | translate : {
              days: bookingInfo.rentalDays,
              time: getFromDateTime()
              } }}</div>
            <!-- <div *ngIf="rentalDaysMessage==='UNDER'">{{ 'bikeshop.rentals.booking.days_reserved_under' | translate : {days: reservation.rentalDays, time: reservation.selectedSlot.label} }}</div> -->
          </div>
        </div>
      </div>

    </div>

    <div class="info-container">
      <div class="label header">{{'bikeshop.rentals.booking.customer_notes' | translate}}</div>
      <textarea [rows]="2" [(ngModel)]="bookingInfo.clientNotes" pInputTextarea [autoResize]="true"
        class="p-fluid"></textarea>
    </div>

    <div class="info-container">
      <div class="label header">{{'bikeshop.rentals.booking.store_notes' | translate}}</div>
      <textarea [rows]="2" [(ngModel)]="bookingInfo.storeNotes" pInputTextarea [autoResize]="true"
        class="p-fluid"></textarea>
    </div>

    <div class="info-container">
      <div class="label header">{{'bikeshop.rentals.booking.rental_products' | translate}}</div>

      <div class="filters">
        <div>
          <div class="category-filter" *ngIf="categories.length > 0">
            <div>{{ 'bikeshop.rentals.products.category' | translate }}:</div>
            <div>
              <div *ngFor="let category of categories" class="filter-items" (click)="selectCategoryFilter(category)"
                [ngClass]="{'selected': category === selectedCategories}">
                <div><span class="fa"
                    [ngClass]="{ 'fa-minus-circle' : category === selectedCategories, 'fa-plus-circle' : category !== selectedCategories }"></span>{{category}}
                </div>
              </div>
            </div>
          </div>
          <div class="brand-filter" *ngIf="brands.length > 0">
            <div>{{ 'bikeshop.rentals.products.brand' | translate }}:</div>
            <div>
              <div *ngFor="let brand of brands" class="filter-items" (click)="selectBrandFilter(brand)"
                [ngClass]="{'selected': brand === selectedBrands}">
                <div><span class="fa"
                    [ngClass]="{ 'fa-minus-circle' : brand === selectedBrands, 'fa-plus-circle' : brand !== selectedBrands }"></span>{{brand}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex" style="justify-content: space-between;align-items: flex-end;"
          *ngIf="products && products.length > 0">
          <div [ngClass]="{'red': getSelectedProducts().length === 0 }">{{
            'bikeshop.rentals.booking.select_products' | translate}}</div>
          <div class="filter-right">
            <div class="p-inputgroup" style="margin-left: 30px; width: 300px; float: left;">
              <input type="text" pInputText placeholder="{{ 'general.search' | translate }}"
                (input)="setSearch($event.target['value'] )" />
              <span class="p-inputgroup-addon"><i class="hubtiger-search"></i></span>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="bikesLoading" style="margin-top: 64px;display: flex;justify-content: center;">
        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
        </p-progressSpinner>
      </div>

      <div class="products-container" id="product-container" *ngIf="!bikesLoading">
        <div *ngFor="let product of filteredProducts" class="product-item" [ngClass]="{ 'selected': product.selected }"
          (click)="addProduct(product)">
          <div class="image">
            <div
              [ngStyle]="{'background-image' : 'url('+(product.imageURL ? product.imageURL : '/assets/no-image-placeholder.png')+')'}">
            </div>
          </div>
          <div class="category">{{product.categoryName}}</div>
          <div class="title">{{product.brand}} {{product.model}}</div>
          <div class="info">{{product.color}} ({{product.size}})</div>
          <div class="info">{{product.serialNumber}}</div>
          <div class="requires-accessory" *ngIf="product.requiresAccessories"
            [ngClass]="{'required-accessory-selected' : product.selected && hasRequiredAccessory(product), 'required-accessory-not-selected' : product.selected && !hasRequiredAccessory(product)}">
            {{ 'bikeshop.rentals.booking.required_accessory' | translate }}</div>
        </div>
      </div>
    </div>

    <div style="margin-top: 32px;margin-left: 16px;" *ngIf="getSelectedProducts().length > 0">
      <div class="label header">{{'bikeshop.rentals.booking.selected_products' | translate}}</div>
    </div>

    <div *ngFor="let product of getSelectedProducts()" class="info-container">
      <div class="flex" style="justify-content: space-between; align-items: center; margin-bottom: 8px;">
        <div class="selected-bike">
          <div class="header">{{product.brand}} {{product.model}} / {{product.color}} ({{product.size}})</div>
          <!-- <span class="sub-header">{{product.color}} ({{product.size}})</span>  -->
          <div class="sub-header">{{product.serialNumber}}</div>
        </div>
        <button pButton (click)="product.selected = false;" class="p-button-raised"
          label="{{'bikeshop.rentals.booking.remove_product' | translate}}"></button>
      </div>
      <p-accordion>
        <p-accordionTab
          header="{{'bikeshop.rentals.booking.add_required_accessory' | translate}}    {{ getSelectedCount(product.requredAccessoryOptions) > 0 ? ('('+getSelectedCount(product.requredAccessoryOptions) + ' ' +('bikeshop.rentals.booking.selected' | translate)) +')' : '' }}"
          [ngClass]="{ 'red': !hasRequiredAccessory(product)}" *ngIf="product.requiresAccessories">
          <div *ngIf="!product.requredAccessoryOptions || product.requredAccessoryOptions.length === 0" class="red">
            {{ 'bikeshop.rentals.booking.no_required_accessories_avaliable' | translate }}
          </div>
          <div class="filters">
            <div>
              <div class="category-filter" *ngIf="getAccessoryCategories(product.requredAccessoryOptions).length > 0">
                <div>{{ 'bikeshop.rentals.products.category' | translate }}:</div>
                <div>
                  <div *ngFor="let category of getAccessoryCategories(product.requredAccessoryOptions)" class="filter-items" (click)="product.selectedRequiredCategory === category ? product.selectedRequiredCategory = null : product.selectedRequiredCategory = category;"
                    [ngClass]="{'selected': category === product.selectedRequiredCategory}">
                    <div><span class="fa"
                        [ngClass]="{ 'fa-minus-circle' : category === product.selectedRequiredCategory, 'fa-plus-circle' : category !== product.selectedRequiredCategory }"></span>{{category}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="brand-filter" *ngIf="getAccessoryBrand(product.requredAccessoryOptions).length > 0">
                <div>{{ 'bikeshop.rentals.products.brand' | translate }}:</div>
                <div>
                  <div *ngFor="let brand of getAccessoryBrand(product.requredAccessoryOptions)" class="filter-items" (click)="product.selectedRequiredBrand === brand ? product.selectedRequiredBrand = null : product.selectedRequiredBrand = brand;"
                    [ngClass]="{'selected': brand === product.selectedRequiredBrand}">
                    <div><span class="fa"
                        [ngClass]="{ 'fa-minus-circle' : brand === product.selectedRequiredBrand, 'fa-plus-circle' : brand !== product.selectedRequiredBrand }"></span>{{brand}}
                    </div>
                  </div>
                </div>
              </div>
            </div>            
          </div>
          <div class="accessories-container"
            *ngIf="product.requredAccessoryOptions && product.requredAccessoryOptions.length > 0">
            <div *ngFor="let accessory of getFilteredAccessories(product.requredAccessoryOptions, product.selectedRequiredCategory, product.selectedRequiredBrand)" class="accessories-item"
              [ngClass]="{ 'selected': accessory.selected, 'used': !accessory.selected && isAccessoryAlreadyUsed(accessory, 'REQUIRED_ACCESSORY') }"
              (click)="!accessory.selected && isAccessoryAlreadyUsed(accessory, 'REQUIRED_ACCESSORY') ? null : addAccessory(accessory)">
              <div class="image">
                <div
                  [ngStyle]="{'background-image' : 'url('+(accessory.imageURL ? accessory.imageURL : '/assets/no-image-placeholder.png')+')'}">
                </div>
              </div>
              <div class="category">{{accessory.categoryName}}</div>
              <div class="title">{{accessory.brand}} {{accessory.name}}</div>
              <div class="info">{{accessory.color}} ({{accessory.size}})</div>
              <div class="info">{{accessory.serialNumber}}</div>
            </div>
          </div>
        </p-accordionTab>
        <p-accordionTab
          header="{{'bikeshop.rentals.booking.optional_accessories' | translate}}    {{ getSelectedCount(product.accessoryOptions) > 0 ? ('('+getSelectedCount(product.accessoryOptions) + ' ' +('bikeshop.rentals.booking.selected' | translate)) +')' : '' }}"
          *ngIf="product.accessoryOptions && product.accessoryOptions.length > 0">
          <div class="filters">
            <div>
              <div class="category-filter" *ngIf="getAccessoryCategories(product.accessoryOptions).length > 0">
                <div>{{ 'bikeshop.rentals.products.category' | translate }}:</div>
                <div>
                  <div *ngFor="let category of getAccessoryCategories(product.accessoryOptions)" class="filter-items" (click)="product.selectedCategory === category ? product.selectedCategory = null : product.selectedCategory = category;"
                    [ngClass]="{'selected': category === product.selectedCategory}">
                    <div><span class="fa"
                        [ngClass]="{ 'fa-minus-circle' : category === product.selectedCategory, 'fa-plus-circle' : category !== product.selectedCategory }"></span>{{category}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="brand-filter" *ngIf="getAccessoryBrand(product.accessoryOptions).length > 0">
                <div>{{ 'bikeshop.rentals.products.brand' | translate }}:</div>
                <div>
                  <div *ngFor="let brand of getAccessoryBrand(product.accessoryOptions)" class="filter-items" (click)="product.selectedBrand === brand ? product.selectedBrand = null : product.selectedBrand = brand;"
                    [ngClass]="{'selected': brand === product.selectedBrand}">
                    <div><span class="fa"
                        [ngClass]="{ 'fa-minus-circle' : brand === product.selectedBrand, 'fa-plus-circle' : brand !== product.selectedBrand }"></span>{{brand}}
                    </div>
                  </div>
                </div>
              </div>
            </div>            
          </div>
          <div class="accessories-container">              
            <div *ngFor="let accessory of getFilteredAccessories(product.accessoryOptions, product.selectedCategory, product.selectedBrand)" class="accessories-item"
              [ngClass]="{ 'selected': accessory.selected, 'used': !accessory.selected && isAccessoryAlreadyUsed(accessory, 'OPTIONAL_ACCESSORY') }"
              (click)="!accessory.selected && isAccessoryAlreadyUsed(accessory, 'OPTIONAL_ACCESSORY') ? null : addAccessory(accessory)">
              <div class="image">
                <div
                  [ngStyle]="{'background-image' : 'url('+(accessory.imageURL ? accessory.imageURL : '/assets/no-image-placeholder.png')+')'}">
                </div>
              </div>
              <div class="category">{{accessory.categoryName}}</div>
              <div class="title">{{accessory.brand}} {{accessory.name}}</div>
              <div class="info">{{accessory.color}} ({{accessory.size}})</div>
              <div class="info">{{accessory.serialNumber}}</div>
            </div>
          </div>
        </p-accordionTab>
        <p-accordionTab header="{{ 'bikeshop.rentals.booking.complete_custom_questions' | translate }}"
          [ngClass]="{ 'red': hasMandatoryQuestion(product)}"
          *ngIf="product.customCategoryQuestions && product.customCategoryQuestions.length > 0">
          <div *ngFor="let question of product.customCategoryQuestions;let i = index;" class="row"
            [ngClass]="{'margin-top-8': i > 0}">
            <div class="col-md-3 label" [ngClass]="{'red': question.mandatory && !question.response}">
              {{question.question}}</div>
            <div class="col-md-9">
              <div class="p-inputgroup" *ngIf="question.controlType === 'TEXTINPUT'">
                <span class="p-inputgroup-addon"></span>
                <input type="text" pInputText [(ngModel)]="question.response" [placeholder]="question.hint">
              </div>
              <div class="p-inputgroup" *ngIf="question.controlType === 'TEXTAREA'">
                <textarea rows="5" pInputTextarea [(ngModel)]="question.response"
                  [placeholder]="question.hint"></textarea>
              </div>
              <div class="p-inputgroup" *ngIf="question.controlType === 'CHECKBOX'">
                <p-checkbox [(ngModel)]="question.response" [binary]="true" inputId="binary"></p-checkbox>
                <small style="margin-left: 8px;font-style: italic;">{{question.hint}}</small>
              </div>
            </div>
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>


    <!-- <div class="waiver-container info-container">
      <p-panel header="{{ 'bikeshop.rentals.booking.waiver_text' | translate }}" [toggleable]="true" [collapsed]="true">
        <div [innerHTML]="rentalStoreRules.waiverTerms" class="waiver-terms"></div>
        <canvas #canvas class="signature-canvas" width="760" height="200">
          Canvas does not work on this browser, upgrade browser or try another
        </canvas>
        <div class="row margin-top-16">
          <div class="col-md-8"></div>
          <div class="col-md-4">
            <div style="display: flex; justify-content:flex-end;">
              <button pButton type="button" class="p-button-raised alternate" (click)="clear()"
                [disabled]="!isSignatureValid() || this.savingReservation"
                label="{{ 'general.clear' | translate}}"></button>
            </div>
          </div>
        </div>
      </p-panel>
    </div> -->

    <div class="info-container" *ngIf="hasCouponsSetup">
      <div class="label header">{{ 'bikeshop.rentals.booking.coupon' | translate }}</div>

      <div class="row margin-top-16">
        <div class="col-md-2 label">{{ "bikeshop.modal.update_job_card.job_card.coupon_code" | translate }}:</div>
        <div class="col-md-4 value">
          <div class="p-inputgroup">
            <input pInputText type="text" [(ngModel)]="bookingInfo.discountCode"
              [disabled]="!bookingInfo.userID || !bookingInfo.fromDate" (keydown)="inputChanged()"
              (ngModelChange)="bookingInfo.discountCode = $event.toUpperCase();couponError = null;couponCodeValid = false"
              (keyup.enter)="verifyCouponCode()" />
            <span *ngIf="!verifyingCouponCode" class="p-inputgroup-addon" (click)="verifyCouponCode()">
              <i class="fa fa-check"></i>
            </span>
            <span *ngIf="verifyingCouponCode" class="p-inputgroup-addon">
              <i class="fa fa-spinner fa-pulse"></i>
            </span>
          </div>
        </div>
        <div class="col-md-6 flex">
          <small class="red" *ngIf="!bookingInfo.userID || !bookingInfo.fromDate">{{
            'bikeshop.rentals.booking.coupon-validation' | translate }}</small>
        </div>
      </div>
      <div *ngIf="couponCodeValid && bookingInfo.discountCode" class="row margin-top-8">
        <div class="col-md-2"></div>
        <div class="col-md-10 coupon-valid">{{ "error.coupons.coupon_code_valid" | translate }}</div>
      </div>
      <div *ngIf="couponError" class="row margin-top-8">
        <div class="col-md-2"></div>
        <div class="col-md-10 coupon-invalid">{{ couponError | translate }}</div>
      </div>
    </div>


    <div class="margin-top-16 button-container">
      <div class="row margin-bottom-16" *ngIf="!isValid()">
        <div class="col-md-12">
          <div class="red" style="font-size: 16px; text-align: right;">{{
            'bikeshop.rentals.products.validation_message' | translate }}</div>
        </div>
      </div>
      <div style="display: flex; justify-content: space-between;">
        <div style="display: flex;">
        </div>
        <button *ngIf="!savingReservation" pButton (click)="createReservation()" class="p-button-raised"
          label="{{'bikeshop.general.save' | translate}}" style="width: 200px;" [disabled]="!isValid()"></button>
        <div *ngIf="savingReservation">
          <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s"></p-progressSpinner>
        </div>
      </div>
    </div>

  </div>
</div>


<p-confirmDialog key="add_edit_rental_product"></p-confirmDialog>